import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getAttendanceById, updateAttendance, getAllEmployees } from "adminApi/HumanResources/Attendance";
import Spinner from "Common/Globle/Spinner";
import AttendanceForm from "../AddAttendance/components/AttendanceForm";
import fields from "../json/Attendance.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";
import { AttendanceRules } from "validation/ValidationRules";
import { validateForm } from "utils/validation";

const EditAttendance = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { formdata } = fields;

  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setErrors, setValues } = useFormChange(
    initialValues,
    AttendanceRules
  );

  // State for fetching attendance by ID
  const [loadingAttendance, setLoadingAttendance] = React.useState(true);

  // Fetch employees for select
  const { data: employeeData, loading: empLoading } = useFetchAllData(getAllEmployees);

  useEffect(() => {
    const fetchData = async () => {
      setLoadingAttendance(true);
      const res = await getAttendanceById(id);
      if (res.success) {
        const data = res.data;
        // Format dates for datetime-local input
        const formattedData = { ...data };
        if (data.sign_in) formattedData.sign_in = new Date(data.sign_in).toISOString().slice(0, 16);
        if (data.sign_out) formattedData.sign_out = new Date(data.sign_out).toISOString().slice(0, 16);
        if (data.attendance_date) formattedData.attendance_date = new Date(data.attendance_date).toISOString().split('T')[0];
        setValues(formattedData);
      }
    };
    fetchData();
  }, [id, setValues]);

  // Submit Hook
  const { handleSubmit, loading: submitLoading } = useFormSubmit(
    (formValues) => updateAttendance(id, formValues),
    (vals) => validateForm(vals, AttendanceRules),
    () => navigate("/admin/attendance"),
    "Attendance updated successfully!"
  );

  return (
    <>
      {(submitLoading || empLoading) && <Spinner isSpinner={true} />}
      <AttendanceForm
        fields={formdata}
        values={values}
        errors={errors}
        employees={employeeData}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={submitLoading}
        title="Edit Attendance Entry"
      />
    </>
  );
};

export default EditAttendance;
